import EventDispatcher from "../../utils/manager/manager/eventdispatcher/EventDispatcher";

class SuccessNotificationManager extends EventDispatcher
{

};

const SUCCESSNOTIFICATIONMANAGER = new SuccessNotificationManager();
export default SUCCESSNOTIFICATIONMANAGER;